import { DynamicModulesConfigMap, DynamicModuleSlug } from '../dynamic-modules.types';
import { initDynamicModule } from '../dynamic-modules.utils';
import { GameConfigResult } from './game-config.types';

export const initGameConfigModule = async (configMap: DynamicModulesConfigMap) =>
  initDynamicModule<GameConfigResult>(DynamicModuleSlug.GAME_CONFIG, configMap);
